export const COLUMNS = [
  {
    field: 'name',
    headerName: 'Nome',
    flex: 1,
  },
]
